import React from "react";

var controller = new AbortController();
var signal = controller.signal;

function debounce(func, wait, immediate) {
  var timeout;

  return function executedFunction() {
    var context = this;
    var args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

const types = {
  books: (val) =>
    `https://cors-anywhere.herokuapp.com/http://openlibrary.org/search.json?title=${val}`,
  movies: (val) =>
    `https://cors-anywhere.herokuapp.com/http://www.omdbapi.com/?s=${val}&apikey=1fb06c00`,
  shows: (val) =>
    `https://cors-anywhere.herokuapp.com/http://api.tvmaze.com/search/shows?q=${val}`,
  songs: (val) => `https://itunes.apple.com/search?term=${val}`,
};

export const Search = ({ type, updateState }) => {
  const [query, setQuery] = React.useState("");
  const [list, setList] = React.useState([]);
  const [data, setData] = React.useState({});

  React.useEffect(() => {
    setList([]);
    switch (type) {
      case "books":
        if (data.numFound)
          for (let i = 0; i < Math.min(5, data.numFound); ++i) {
            const el = data.docs[i];
            const name = el.title_suggest;
            const img = el.cover_i
              ? `https://covers.openlibrary.org/b/id/${el.cover_i}-L.jpg`
              : "/noimage.png";
            setList((l) => {
              return [...l, { name, img }];
            });
          }
        break;
      case "movies":
        if (data.Response)
          for (let i = 0; i < Math.min(5, data.totalResults); ++i) {
            const el = data.Search[i];
            const name = el.Title;
            const img = el.Poster ? el.Poster : "/noimage.png";
            setList((l) => {
              return [...l, { name, img }];
            });
          }
        break;
      case "shows":
        if (data.length > 0)
          for (let i = 0; i < Math.min(5, data.length); ++i) {
            const el = data[i].show;
            const name = el.name;
            const img = el.image ? el.image.medium : "/noimage.png";
            setList((l) => {
              return [...l, { name, img }];
            });
          }
        break;
      case "songs":
        if (data.resultCount)
          for (let i = 0; i < Math.min(5, data.resultCount); ++i) {
            const el = data.results[i];
            const name = el.trackName;
            const img = el.artworkUrl100 ? el.artworkUrl100 : "/noimage.png";

            setList((l) => {
              return [...l, { name, img }];
            });
          }
        break;
      default:
    }
  }, [data]);

  const getResponse = debounce(
    async (url) => {
      if (signal.aborted) controller.abort();
      await fetch(url, {
        header: { "X-Requested-With": "XMLHttpRequest" },
        signal,
      })
        .then((data) => data.json())
        .then((json) => {
          setData(json);
          setList([]);
        });
    },
    700,
    false
  );

  React.useEffect(() => {
    const url = types[type](query.split(" ").join("+"));

    if (query !== "") {
      getResponse(url);
    }
  }, [query, type]);

  const handleChange = (value) => {
    setQuery(value);
  };

  return (
    <div className="searchArea">
      <input
        type="text"
        value={query}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={`Suggest me a ${type.substring(0, type.length - 1)}`}
      />
      <ul>
        {list.map((e, i) => (
          <li key={i} onClick={() => updateState({ ...e })}>
            <div style={{ backgroundImage: `url(${e.img})` }}></div>

            <p>
              {e.name &&
                (e.name.length < 45 ? e.name : e.name.substring(0, 45))}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};
